$(window).bind('load', function() {
    if (window.location.hash) {
        var hash = window.location.hash.substring(1);

        if (hash.substring(0, 6) == 'anchor') {
            window.scrollToId('js-' + hash);

            if (history.pushState) {
                history.pushState(null, null, window.location.pathname);
            }
        }
    }
});
